import React__default from 'react';
import { u as useDropdownIsMobile } from './DropdownIsMobileContext-DIYFOYAu.js';
import { D as DesktopContainer } from './DropdownDesktopContainer-BL9RS-DO.js';
import { M as MobileContainer } from './DropdownMobileContainer-pPtE8IRO.js';

function DropdownContainer({
  isOpen,
  onClose,
  secondaryViewCloseButtonLabel,
  children,
  shadowRoot,
  trigger,
  anchorEl,
  preRender,
  postRender,
  selectedValue,
  onChange,
  noWrap,
  name,
  focusSelected,
  forceOpen,
  popperRef,
  openDirection,
  forceDirection
}) {
  const isMobile = useDropdownIsMobile();
  if (isMobile) {
    return /*#__PURE__*/React__default.createElement(MobileContainer, {
      isOpen: isOpen,
      onClose: onClose,
      anchorEl: anchorEl,
      secondaryViewCloseButtonLabel: secondaryViewCloseButtonLabel,
      preRender: preRender,
      postRender: postRender,
      trigger: trigger,
      name: name,
      selectedValue: selectedValue,
      onChange: onChange
    }, children);
  }
  return /*#__PURE__*/React__default.createElement(DesktopContainer, {
    isOpen: isOpen,
    onClose: onClose,
    shadowRoot: shadowRoot,
    trigger: trigger,
    preRender: preRender,
    selectedValue: selectedValue,
    onChange: onChange,
    noWrap: noWrap,
    postRender: postRender,
    focusSelected: focusSelected,
    anchorEl: anchorEl,
    forceOpen: forceOpen,
    popperRef: popperRef,
    openDirection: openDirection,
    forceDirection: forceDirection
  }, children);
}

export { DropdownContainer as D };
//# sourceMappingURL=DropdownContainer-BZoY0pG7.js.map
